import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { assinarErrosRegistrados } from '../nucleo/log-erros';
import { useToast } from './toast';

/** CRM novo desenho, lote 0: a pessoa fica sabendo que o erro foi registrado e que a equipe foi avisada. */
export function AvisoErroRegistrado() {
  const { t } = useTranslation();
  const toast = useToast();
  useEffect(() => assinarErrosRegistrados(() => toast.info(t('logErros.registrado'))), [t, toast]);
  return null;
}
